export const environment = {
  production: true,
  apiUrl: 'https://rbms-hn-api.giaothong247.vn/',
  apiUrlHrm :'https://api.giaothong247.vn/'
};
